const INITIAL_STATE = {
  data: {},
  tickets: {},
  report:{},
  errors: {}
}
      
const customerComplaintsReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CUSTOMER_COMPLAINTS_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, report: action.data }
  case 'GET_CUSTOMER_COMPLAINTS_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, tickets: action.data }
  case 'GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default customerComplaintsReport;